module.exports = __webpack_public_path__ + "static/media/stele.b7a99210.m4a";